/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Platform, Animated, StyleProp, ViewStyle, StyleSheet, View, TextStyle } from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  Text as SVG_Text,
  TSpan as SVG_TSpan,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const TSpan = Animated.createAnimatedComponent(SVG_TSpan);
const Text = Animated.createAnimatedComponent(SVG_Text);
const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
import FontList from "react-native-font-list";
/***/

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="158" height="40" viewBox="0 0 158 40" fill="none"> <desc id="IMP.BLUE">{"#Button_20_20Main":{"type":"SELECTOR","constraint":"none","width":158,"height":40},"#Rectangle_2051":{"type":"SELECTOR","constraint":"none","width":158,"height":40},"#JOIN_20THE_20MAIN_20TAB":{"type":"SELECTOR","constraint":"xMaxYMid meet","width":157.31304931640625,"height":40},"#Vector":{"type":"SELECTOR","constraint":"xMinYMid meet","width":17.906665802001953,"height":17},"transforms":{},"tProps":{"type":"PROPS","NewProductButton?":"tButtonProps","onAnimationComplete?":"() => void"},"#NewProductButton":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.NewProductButton?.onPress","animation":"touchableOpacity"},"constraint":"none","width":158,"height":40},"#ImportButton":{"type":"SELECTOR","constraint":"none","width":158,"height":40},"#DownloadIcon":{"type":"SELECTOR","constraint":"xMinYMid meet","width":16,"height":16},"#Import":{"type":"SELECTOR","constraint":"xMaxYMid meet","width":60,"height":26},"#Product":{"type":"SELECTOR","constraint":"xMaxYMid meet","width":73,"height":25}}</desc>
 * <g id="NewProductButton">
 * <rect id="Rectangle 51" width="158" height="40" rx="2" fill="#2C4B46"/>
 * <text id="Product" fill="white" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14" font-weight="600" letter-spacing="0.06em"><tspan x="92.5" y="0.441998">      </tspan><tspan x="56.3677" y="25.442">PRODUCT</tspan></text>
 * <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M39.546 18.4561V12.0439C39.546 11.4673 39.0538 11 38.4465 11C37.8392 11 37.347 11.4673 37.347 12.0439V18.4561H30.5927C29.9854 18.4561 29.4932 18.9235 29.4932 19.5C29.4932 20.0765 29.9854 20.5439 30.5927 20.5439H37.347V26.9561C37.347 27.5327 37.8392 28 38.4465 28C39.0538 28 39.546 27.5327 39.546 26.9561V20.5439H46.3003C46.9076 20.5439 47.3998 20.0765 47.3998 19.5C47.3998 18.9235 46.9076 18.4561 46.3003 18.4561H39.546Z" fill="white"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Button_20_20Main": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 158,
 * 		"height": 40
 * 	},
 * 	"#Rectangle_2051": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 158,
 * 		"height": 40
 * 	},
 * 	"#JOIN_20THE_20MAIN_20TAB": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMaxYMid meet",
 * 		"width": 157.31304931640625,
 * 		"height": 40
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMid meet",
 * 		"width": 17.906665802001953,
 * 		"height": 17
 * 	},
 * 	"transforms": {},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"NewProductButton?": "tButtonProps",
 * 		"onAnimationComplete?": "() => void"
 * 	},
 * 	"#NewProductButton": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.NewProductButton?.onPress",
 * 			"animation": "touchableOpacity"
 * 		},
 * 		"constraint": "none",
 * 		"width": 158,
 * 		"height": 40
 * 	},
 * 	"#ImportButton": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 158,
 * 		"height": 40
 * 	},
 * 	"#DownloadIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMid meet",
 * 		"width": 16,
 * 		"height": 16
 * 	},
 * 	"#Import": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMaxYMid meet",
 * 		"width": 60,
 * 		"height": 26
 * 	},
 * 	"#Product": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMaxYMid meet",
 * 		"width": 73,
 * 		"height": 25
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  NewProductButton?: tButtonProps;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Button Prop Types */

type tButtonProps = {
  onPress: () => void;
} & GProps;
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const NewProductButton = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  NewProductButton?: tButtonProps;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 158,
      height: 40,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;

  function checkFont(myStrFamily: string) {
    let aReturnFamily;

    if (FontList) {
      FontList.get((fontFamilies: Array<string>) => {
        if (fontFamilies.includes(myStrFamily)) {
          aReturnFamily = myStrFamily;
        } else {
          console.warn(`"${myStrFamily}" is not a valid font. Using "${fontFamilies[0]}" instead. `);
          aReturnFamily = fontFamilies[0];
        }
      });
    } else {
      aReturnFamily = myStrFamily;
    }

    return aReturnFamily;
  }

  /** Component Internal State */

  const [buttonState, setButtonState] = React.useState<{
    NewProductButtonButtonOpacity: number;
  }>({
    NewProductButtonButtonOpacity: 1,
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */
  /** End Custom React-Hooks */

  /** Button Wrapper */
  // #region NewProductButton Button Handlers

  const { NewProductButton = {} } = props;
  const { onPress: NewProductButtonOnPress, ...NewProductButtonProps } = NewProductButton as tButtonProps;

  const NewProductButtonButtonPressInFunction = () => 0;

  const NewProductButtonButtonPressOutFunction = NewProductButtonOnPress;

  const NewProductButtonButtonActive = (callback?: () => void) => {
    setButtonState({ ...buttonState, NewProductButtonButtonOpacity: 0.2 });

    if (callback) {
      callback();
    }
  };

  const NewProductButtonButtonInactive = (callback?: () => void) => {
    setButtonState({ ...buttonState, NewProductButtonButtonOpacity: 1 });

    if (callback) {
      callback();
    }
  };

  const NewProductButtonOnPressIn = () => {
    NewProductButtonButtonActive(NewProductButtonButtonPressInFunction);
  };

  const NewProductButtonOnPressOut = () => {
    NewProductButtonButtonInactive(NewProductButtonButtonPressOutFunction);
  };
  /***/
  // #endregion

  /** End Button Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} style={svgStyle}>
          <G
            id="NewProductButton"
            opacity={buttonState.NewProductButtonButtonOpacity}
            onMouseDown={NewProductButtonOnPressIn}
            onMouseUp={NewProductButtonOnPressOut}
            cursor="pointer"
            {...NewProductButtonProps}
          >
            <Svg preserveAspectRatio="none" viewBox="0 0 158 40">
              <Path
                id="Rectangle_2051"
                fill="#2C4B46"
                d="M2 0 H156 a2,2 0 0 1 2,2 V38 a2,2 0 0 1 -2,2 H2 a2,2 0 0 1 -2,-2 V2 a2,2 0 0 1 2,-2z"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMaxYMid meet" viewBox="0 0 158 40">
              <Text
                id="Product"
                fill="white"
                fontSize={14}
                fontWeight={600}
                letterSpacing="0.06em"
                fontFamily={checkFont("Raleway")}
              >
                <TSpan x={92.5} y={0.441998} id="Product_elem0" />
                <TSpan x={56.3677} y={25.442} id="Product_elem1">
                  {"PRODUCT"}
                </TSpan>
              </Text>
            </Svg>
            <Svg preserveAspectRatio="xMinYMid meet" viewBox="0 0 158 40">
              <Path
                id="Vector"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.546 18.4561V12.0439C39.546 11.4673 39.0538 11 38.4465 11C37.8392 11 37.347 11.4673 37.347 12.0439V18.4561H30.5927C29.9854 18.4561 29.4932 18.9235 29.4932 19.5C29.4932 20.0765 29.9854 20.5439 30.5927 20.5439H37.347V26.9561C37.347 27.5327 37.8392 28 38.4465 28C39.0538 28 39.546 27.5327 39.546 26.9561V20.5439H46.3003C46.9076 20.5439 47.3998 20.0765 47.3998 19.5C47.3998 18.9235 46.9076 18.4561 46.3003 18.4561H39.546Z"
                fill="white"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 158 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Rectangle_2051"
          fill="#2C4B46"
          d="M2 0 H156 a2,2 0 0 1 2,2 V38 a2,2 0 0 1 -2,2 H2 a2,2 0 0 1 -2,-2 V2 a2,2 0 0 1 2,-2z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMaxYMid meet"
        viewBox="0 0 158 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Text
          id="Product"
          fill="white"
          fontSize={14}
          fontWeight={600}
          letterSpacing="0.06em"
          fontFamily={checkFont("Raleway")}
        >
          <TSpan x={92.5} y={0.441998} id="Product_elem0" />
          <TSpan x={56.3677} y={25.442} id="Product_elem1">
            {"PRODUCT"}
          </TSpan>
        </Text>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMid meet"
        viewBox="0 0 158 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.546 18.4561V12.0439C39.546 11.4673 39.0538 11 38.4465 11C37.8392 11 37.347 11.4673 37.347 12.0439V18.4561H30.5927C29.9854 18.4561 29.4932 18.9235 29.4932 19.5C29.4932 20.0765 29.9854 20.5439 30.5927 20.5439H37.347V26.9561C37.347 27.5327 37.8392 28 38.4465 28C39.0538 28 39.546 27.5327 39.546 26.9561V20.5439H46.3003C46.9076 20.5439 47.3998 20.0765 47.3998 19.5C47.3998 18.9235 46.9076 18.4561 46.3003 18.4561H39.546Z"
          fill="white"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(NewProductButton);
